/** Shared client for the SUNTRONIX Business Service Layer (/api/services). Used by dashboards, portal and admin tools. */
import api from "@/lib/api";

const ELEV_KEY = "st.elevation";

export const getElevation = () => {
  try { const e = JSON.parse(sessionStorage.getItem(ELEV_KEY) || "null"); return e && new Date(e.expires_at) > new Date() ? e : null; } catch { return null; }
};
export const setElevation = (e) => { try { sessionStorage.setItem(ELEV_KEY, JSON.stringify(e)); } catch { /* ignore */ } };
export const clearElevation = () => { try { sessionStorage.removeItem(ELEV_KEY); } catch { /* ignore */ } };
export const newIdempotencyKey = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

const split = (key) => { const [resource, action] = key.split("."); return `${resource}/${action}`; };

export const svc = {
  catalog: (channel = "UI") => api.get(`/services/catalog?channel=${channel}`).then((r) => r.data),
  read: (key, params = {}, channel) => api.get(`/services/${split(key)}`, { params, headers: channel ? { "X-Channel": channel } : {} }).then((r) => r.data),
  write: (key, params = {}, { confirm = false, idempotencyKey, channel } = {}) => {
    const headers = {};
    if (idempotencyKey) headers["Idempotency-Key"] = idempotencyKey;
    const e = getElevation();
    if (e) headers["X-Elevation-Token"] = e.token;
    if (channel) headers["X-Channel"] = channel;
    return api.post(`/services/${split(key)}`, { ...params, confirm }, { headers }).then((r) => r.data);
  },
  elevate: async ({ password, code }) => { const { data } = await api.post("/services/elevate", { password, code }); setElevation(data); return data; },
  elevation: () => api.get("/services/elevation", { headers: getElevation() ? { "X-Elevation-Token": getElevation().token } : {} }).then((r) => r.data),
  audit: (params = {}) => api.get("/services/audit", { params }).then((r) => r.data),
  limits: () => api.get("/services/limits").then((r) => r.data),
  putLimits: (limits) => api.put("/services/limits", limits).then((r) => r.data),
};

export const isElevationError = (e) => e?.response?.status === 403 && /Elevated permission/i.test(e.response?.data?.detail || "");
export const isConfirmError = (e) => e?.response?.status === 428;
